var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import { TypeActionPvp } from "./actionPvp";
var initial = {};
export var reducerPVP = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionPvp.InfoReceived:
            return __assign({}, state, { eventProgress: action.response.eventProgress, leagueId: action.response.leagueId, leagueXp: action.response.leagueXp, unitAmount: action.response.unitAmount });
        case TypeActionPvp.AddUnits: {
            return __assign({}, state, { unitAmount: action.unitsAmount.add(state.unitAmount || Long.ZERO) });
        }
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/pvp/reducerPvp.ts
// module id = 2972
// module chunks = 3